const MAX_INT_32 = 2 ** 31 - 1;
const MIN_INT_32 = -(2 ** 31);

const log2 = (x) => (x > 0 ? Math.ceil(Math.log2(x)) : 0);

export { log2, MAX_INT_32, MIN_INT_32 };
